import React, { useCallback, useContext, useEffect, useState } from "react";
import { AuthContext } from "../../AuthProvider";
import { handleError } from "../../utils/handleError";
import { supabase } from "../../supabaseClient";
import type { Profile } from "../../types/Profile";

export function useProfile() {
  const { session } = useContext(AuthContext);
  const [profile, setProfile] = useState<Profile | null>(null);
  const [loading, setLoading] = useState(true);

  const getProfile = useCallback(async () => {
    setLoading(true);
    try {
      let { data, error, status } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", session?.user?.id!)
        .single();

      if (error && status !== 406) {
        throw error;
      }

      if (data) {
        setProfile(data);
      }
    } catch (error) {
      handleError(error as Error);
    } finally {
      setLoading(false);
    }
  }, [session?.user?.id]);

  useEffect(() => {
    getProfile();
  }, [getProfile]);

  return { profile, loading };
}
